import { CustomizerStep, CustomizerOptionsKeyValuePair } from "../types/ProductCustomizer";

export function productOptionToString(steps: CustomizerStep[], step: number, option: number): CustomizerOptionsKeyValuePair {
  const key = steps[step].id, title = steps[step].title, option_value = steps[step].options[option].id, option_label = steps[step].options[option].label;
  return { key, title, option_value, option_label };
}